<i18n>
{
	"en": {
		"setupDetails": "EDI Setup",
		"otherOptions": "Other options",
		"codelist": "Codelists"
	},
	"no":{
		"setupDetails": "EDI oppsett",
		"otherOptions": "Andre instillinger",
		"codelist": "Kodelister"
	}
}
</i18n>

<template>
	<div v-if="fetchedMetadata" class="details-grid">

		<div class="navigation">
			<t-tab-list :items="tabs" :selected.sync="selectedTab" sidebar>
				<template v-slot="slotProps">
					<t-tab :value="slotProps.item" :selected="slotProps.isSelected" :sidebar="slotProps.sidebar">
						{{$t(slotProps.item.key)}}
					</t-tab>
				</template>
			</t-tab-list>
		</div>
		<t-pane class="settings-content">
			<component
				:is="selectedTab.id"
				:ref="selectedTab.ref"
				:edisetup="inboundEdiSetting"
				:messageMetadata="metaData"
			/>
		</t-pane>

	</div>
</template>

<script>

import getEdipartMetadatas from '../requests/getEdipartMetadatas';
import SetupDetails from './inbound/SetupDetails.vue';
import OtherOptions from './inbound/OtherOptions.vue';
import Codelists from './common/ManageCodelists.vue';

export default {
	components: { SetupDetails, OtherOptions, Codelists },
	props: { inboundEdiSetting: Object, },
	data() {
		return {
			tabs: [
				{ id:'SetupDetails', key: 'setupDetails', ref: 'setupDetails' },
				{ id:'OtherOptions', key: 'otherOptions', ref: 'optherOptions' },
				{ id:'Codelists', key: 'codelist', ref: 'codelist' }
			],
			selectedTab: { id:'SetupDetails', key: 'setupDetails', ref: 'setupDetails' },
			metaData: null,
			fetchedMetadata: false,
		};
	},

	computed: {
		testModeEnabled() {
			return this.inboundEdiSetting.testMode;
		}
	},

	async mounted() {
		this.metaData = await getEdipartMetadatas();
		this.fetchedMetadata = true;
	},

};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';

.details-grid{
	display: grid;
	grid-template-columns: 240px 1100px;
}

.navigation{
	border-right: 2 px solid get-color($border, 'default');
}
</style>